import { render } from "./InstantOrders.vue?vue&type=template&id=48de4db4&scoped=true"
import script from "./InstantOrders.vue?vue&type=script&lang=js"
export * from "./InstantOrders.vue?vue&type=script&lang=js"

import "./InstantOrders.vue?vue&type=style&index=0&id=48de4db4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48de4db4"]])

export default __exports__